var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0054 1.99025C12.8934 1.48225 14.0001 2.12359 14.0001 3.14759V11.5169C14.0001 12.5403 12.8941 13.1823 12.0054 12.6743L9.33344 11.1476V3.51692L12.0054 1.99025ZM8.0001 3.99892H4.66677C3.84013 3.99809 3.04268 4.30444 2.42921 4.8585C1.81575 5.41256 1.43004 6.17481 1.34696 6.99726C1.26389 7.81971 1.48937 8.64369 1.97964 9.30924C2.46992 9.97479 3.19 10.4344 4.0001 10.5989V12.9989C4.0001 13.4409 4.1757 13.8649 4.48826 14.1774C4.80082 14.49 5.22474 14.6656 5.66677 14.6656C6.1088 14.6656 6.53272 14.49 6.84528 14.1774C7.15784 13.8649 7.33344 13.4409 7.33344 12.9989V10.6656H8.0001V3.99892Z",
    fill: "#25262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.c0d2852a730512ee2234c5efc08a3636.svg";
export { ForwardRef as ReactComponent };